import styled from 'styled-components';

export const ShiftReviewModalStyled = styled.div.attrs({
  className: 'ShiftReviewModalStyled',
})`
  .modal__dialog {
    padding: 1.75rem 1.5rem;
  }
`;

export const ShiftDetails = styled.div.attrs({
  className: 'ShiftDetails',
})`
  margin-top: 1rem;
  margin-bottom: .8rem;

  p {
    margin-bottom: 0.4rem;
  }
`;

export const TextAreaWrapper = styled.div.attrs({
  className: 'TextAreaWrapper',
})`
  margin-bottom: 0.8rem;
`;
